import { useEffect, useState } from "react";
import { AuthorizedLayout } from "../../../../components/AuthorizedLayout";
import { useNavigate, useParams } from "react-router-dom";
import YouTube from "react-youtube";
import api from "../../../../utils/api";
import iconBack from "../../../../assets/Tipode material.png";
import checkIcon from "../../../../assets/Frame 20 (8).png";
import iconHeart from "../../../../assets/Vector (23).png";
import arrowIcon from "../../../../assets/Vector.png";

import "./PlayVideo.css";
import LoadingIcon from "../../../../components/LoadingIcon";
import { generateSlug } from "../../../../utils/slug";
import YoutubeEmbed from "../../../../components/YoutubeEmbed/YoutubeEmbed"

export const PlayVideo = () => {
  const navigate = useNavigate();
  const { cursoId, aulaId } = useParams();
  const [listCourse, setCourse] = useState([]);
  const [loading, setLoading] = useState(false);

  const getCourses = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(
        `/talents/courses/${cursoId}/lessons/${aulaId}/details`
      );
      setCourse(
        {
          id: data?.data?.id,
          ...data?.data?.attributes,
        } || []
      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCourses();
  }, [aulaId]);

  const checkView = async () => {
    try {
      await api.post(
        `/talents/courses/${listCourse?.course?.id}/lessons/${listCourse?.id}/mark_completed`
      );

      setCourse({ ...listCourse, watched: true });
    } catch (error) {
      console.log(error);
    }
  };

  const unmarkView = async () => {
    try {
      await api.post(
        `/talents/courses/${listCourse?.course?.id}/lessons/${listCourse?.id}/unmark_completed`
      );

      setCourse({ ...listCourse, watched: false });
    } catch (error) {
      console.log(error);
    }
  };

  const handleVideoEnd = async () => {
    if (!listCourse?.watched) {
      await checkView();
      setCourse({ ...listCourse, watched: true });
    }
  };

  const handleNavigate = async () => {
    const slug = generateSlug(listCourse?.course?.title)
    navigate(`/course/${slug}/${listCourse?.course?.id}`);
  };

  const nextLeason = async () => {
    navigate(
      `/course/${listCourse?.course?.id}/lesson/${listCourse?.nextLesson?.id}`
    );
  };

  const previousLesson = async () => {
    navigate(
      `/course/${listCourse?.course?.id}/lesson/${listCourse?.previousLesson?.id}`
    );
  };

  const getYouTubeVideoId = (url) => {
    try {
      const urlObj = new URL(url);
      if (urlObj.hostname === "youtu.be") {
        return urlObj.pathname.substring(1);
      }
      return urlObj.searchParams.get("v");
    } catch (error) {
      return null;
    }
  };

  const videoId = getYouTubeVideoId(listCourse?.youtubeLink);

  const thumbnailUrl = videoId
    ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
    : null;

  return (
    <AuthorizedLayout>
      <>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "70vh",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "250px",
                marginTop: "50px",
              }}
            >
              <LoadingIcon />
            </div>
          </div>
        ) : (
          <div className="containerPlayVideo">
            <div className="containerDetails">
              <div className="containerHeader" onClick={handleNavigate}>
                <img src={iconBack} alt="" />
                <span>{listCourse?.course?.title}</span>
              </div>

              <YoutubeEmbed
                videoId={videoId}
                onVideoEnd={handleVideoEnd}
              />

              <div className="containerTeacher">
                <div className="headers">
                  <div className="containerText2">
                    <div>{listCourse?.title}</div>

                    {Array.isArray(listCourse?.instructors) && listCourse.instructors.length > 0 && (
                      <div className="text2">
                        {listCourse.instructors.length === 1 ? "Participante: " : "Participantes: "}
                        <span>{listCourse.instructors.map((item) => item.name).join(", ") + "."}</span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="description">{listCourse?.summary}</div>
              </div>

              <button
                className={`checkVideo ${listCourse?.watched && "checked"}`}
                onClick={async () => {
                  if (listCourse?.watched) {
                    await unmarkView();
                  } else {
                    await checkView();
                  }
                }}
              >
                <div className="cicle"></div>
                {listCourse.watched && (
                  <img src={checkIcon} alt="" className="imgCheck" />
                )}
                Aula concluída
              </button>

              {listCourse.nextLesson && (
                <>
                  <div className="textSugestao">Próxima aula:</div>
                  <div
                    className={`card ${
                      listCourse?.nextLesson?.watched && "card_checked"
                    }`}
                  >
                    <div
                      className={`thumbnail ${
                        listCourse?.nextLesson?.watched && "thumbnail_checked"
                      }`}
                    >
                      <img src={checkIcon} alt="" className="iconPLay" />
                      {thumbnailUrl && (
                        <img src={thumbnailUrl} alt="" className="thumb" />
                      )}
                    </div>
                    <div className="containerText">
                      <div className="title">
                        {listCourse?.nextLesson?.title}
                      </div>
                      <div>
                        <button
                          className="buttonVIdeo"
                          style={{
                            background: "#EC5569",
                            border: "1px solid #EC5569",
                            color: "#ffffff",
                          }}
                          onClick={nextLeason}
                        >
                          Ver aula
                          <img
                            src={arrowIcon}
                            alt=""
                            style={{
                              width: "7px",
                              height: "11px",
                              marginRight: "10px",
                            }}
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {listCourse.previousLesson && (
                <>
                  <div className="textSugestao">Aula anterior:</div>
                  <div
                    className={`card ${
                      listCourse?.previousLesson?.watched && "card_checked"
                    }`}
                  >
                    <div
                      className={`thumbnail ${
                        listCourse?.previousLesson?.watched &&
                        "thumbnail_checked"
                      }`}
                    >
                      <img src={checkIcon} alt="" className="iconPLay" />
                      {thumbnailUrl && (
                        <img src={thumbnailUrl} alt="" className="thumb" />
                      )}
                    </div>
                    <div className="containerText">
                      <div className="title">
                        {listCourse?.previousLesson?.title}
                      </div>
                      <div>
                        <button
                          className="buttonVIdeo"
                          style={{
                            background: "#0AC6BD",
                            border: "1px solid #0AC6BD",
                            color: "#ffffff",
                          }}
                          onClick={previousLesson}
                        >
                          Rever aula
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </>

      <div
        className={
          listCourse?.length <= 1 ? "footerMobileFixed" : "footerMobile"
        }
      >
        Desenvolvido com
        <img src={iconHeart} alt="" />
        <strong>© eComLovers®</strong>
      </div>
    </AuthorizedLayout>
  );
};
